
    export * from '@nexxe/cds';
    export * from '@nexxe/cds/nexxe-cds.ngfactory';
    import { CdsModuleNgFactory } from '@nexxe/cds/nexxe-cds.ngfactory';
    export default CdsModuleNgFactory;
  